import { API_BASE_URL } from "./env";

// The <audio> element can't send an Authorization header, and voice recordings live in a private
// bucket — so playback goes through the backend proxy (GET /api/voice/audio), which verifies the
// token, signs the private object, and 302-redirects to a short-lived signed URL. The token rides
// in the query, same pattern as the chat SSE stream.
export function voiceAudioSrc(
  audioUrl: string | undefined,
  token: string | null | undefined,
): string | undefined {
  if (!audioUrl) return undefined;
  return `${API_BASE_URL}/voice/audio?src=${encodeURIComponent(audioUrl)}&access_token=${encodeURIComponent(token ?? "")}`;
}
